import angular from 'angular';
import moment from 'moment-timezone';
import '../../../services/appointment';
import '../../../services/area';
import '../../../services/date-handler';
import '../../../services/errors';
import '../../../services/place';
import { sortBy, toArray, filter, map } from 'lodash';

const module = angular.module('whyline.modals.export-csv', ['whyline.services.area', 'whyline.services.errors']);

const ExportCsvController = (
  $scope,
  $translate,
  $uibModalInstance,
  AreaService,
  ErrorService,
  $timeout,
  DateHandlerService,
  PlaceService,
  NotificationService,
  AppointmentService,
  blockUI
) => {
  'ngInject';

  $scope.place = PlaceService.GetCurrent();

  $scope.areasList = [];

  $scope.filters = {
    date: DateHandlerService.getNeutralDate(),
    areas: [],
    showWorkingDay: false,
    hideEmptySlots: false,
  };

  // Dropdown services
  $scope.areasSettings = {
    template: '<b translate>{{option.label}}</b>',
    externalIdProp: '',
    displayProp: 'label',
    idProp: '_id',
    searchField: 'label',
    enableSearch: true,
    keyboardControls: true,
    selectedToTop: true,
    scrollable: true,
  };

  $scope.multiselectTranslations = {
    checkAll: $translate.instant('all'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('select_one_or_more_services'),
    searchPlaceholder: $translate.instant('search_service'),
  };
  
  $scope.calendarDates = {
    from: moment().set({hour:0,minute:0,second:0}).toDate(),
    to: moment().set({hour:23,minute:59,second:59}).toDate()
  };

  $scope.format = $translate.use() === 'en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';

  $scope.dateOptionsFrom = {
    formatYear: 'yy',
    minDate: new Date(2016, 1, 1),
    startingDay: 1,
    timezone: 'utc'
  };

  $scope.dateOptionsTo = {
    formatYear: 'yy',
    minDate: new Date(2016, 1, 1),
    startingDay: 1,
    timezone: 'utc'
  };

  const init = () => {

      // Available processes
      AreaService.GetAgendaAsPromise()
      .then(areas => {
        $timeout(() => {
          $scope.areasList = sortBy(toArray(filter(areas, area => area.appointmentsConfiguration.enabled)), ['label']);
        });
      })
      .catch(ErrorService.handler);
  };



  // Close modal
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  const validForm = () => {

    if(!$scope.filters.areas.length){
      NotificationService.Warning($translate.instant('areas_mandatory'));
      return false;
    }

    if(moment($scope.calendarDates.to).isBefore(moment($scope.calendarDates.from))){
      NotificationService.Warning($translate.instant('second_period_must_be_greater_than_first_one'));
      return false;
    }

    const difference = moment($scope.calendarDates.to).diff(moment($scope.calendarDates.from));
    const duration = moment.duration(difference);
    const days = parseInt(duration.asDays());
    const maxDays = 30;

    if(days > maxDays){
        NotificationService.Warning($translate.instant('schedule_export_csv_max_range'));
        return false;
    }

    return true;
  }

  const getAreasIds = () => map($scope.filters.areas, '_id');

  const getConfiguration = () => {

    const startDate = $scope.calendarDates.from;
    const endDate = $scope.calendarDates.to;

    const configuration = {
      areaIds: getAreasIds(),
      endDate,
      lang: $translate.use(),
      placeId: $scope.place._id,
      startDate,
    };

    return configuration;

  }

  $scope.export = () => {

    if(!validForm()) return;
    
    blockUI.start($translate.instant('loading'));
    
    const configuration = getConfiguration();

    AppointmentService.ExportReservations(configuration)
      .then(() => {
        NotificationService.Success($translate.instant('success'));
        $scope.cancel()
      })
      .catch(ErrorService.handler)
      .then(() => blockUI.stop());
  };

  init();
};

module.exports = module.controller('ExportCsvController', ExportCsvController);
